import React, { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { fetchUserByWallet } from './userUtils';
import ssaltaforceIcon from '../assets/ssaltaforce.png';
import ssalBadge10 from '../assets/10ssal.png';
import ssalBadge15 from '../assets/15ssal.png';
import ssalBadge20 from '../assets/20ssal.png';


export default function SsalsoongiModal({ open, onClose }) {
  const [characters, setCharacters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCharacter, setSelectedCharacter] = useState(null);
  const [userBonus, setUserBonus] = useState(null);
  const [totalSsaltaforce, setTotalSsaltaforce] = useState(null);

  const fetchCharacters = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session?.access_token) throw new Error('Login required');
      const response = await supabase.functions.invoke('get-user-inventory', {
        headers: { Authorization: `Bearer ${session.access_token}` }
      });
      if (response.error) throw new Error(response.error.message || 'Failed to fetch inventory');
      const inventoryData = response.data || [];
      if (inventoryData.length === 0) {
        setCharacters([]);
        setLoading(false);
        return;
      }
      const formattedCharacters = inventoryData.map(item => ({
        index: item.ssi_index,
        name: item.ssi_name,
        image: item.ssi_image_url,
        quantity: item.quantity,
        grade: item.ssi_grade,
        ssaltaforce: item.ssaltaforce
      }));
      setCharacters(formattedCharacters);
    } catch (err) {
      console.error('Error fetching characters:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };


  const fetchBonus = async () => {
    try {
      const data = await fetchUserByWallet();
      setUserBonus(data?.per_sec ?? 1);
      setTotalSsaltaforce(data?.total_ssaltaforce ?? 0);
    } catch {
      setUserBonus(null);
      setTotalSsaltaforce(null);
    }
  };


  const handleUpgradeSuccess = async () => {
    await fetchCharacters();
    await fetchBonus();
    if (selectedCharacter) {
      setTimeout(() => {
        setCharacters(prev => {
          const newC = prev.find(c => c.index === selectedCharacter.index);
          setSelectedCharacter(newC || null);
          return prev;
        });
      }, 10);
    }
  };


  useEffect(() => {
    if (!open) return;
    fetchCharacters();
    fetchBonus();
  }, [open]);

  if (!open) return null;


  const handleCharacterClick = (character) => setSelectedCharacter(character);
  const handleDetailClose = () => setSelectedCharacter(null);


  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: '90%',
          maxWidth: 480,
          maxHeight: '85vh',
          background: 'linear-gradient(180deg, #4FC3D4 0%, #3AA8B8 100%)',
          borderRadius: 24,
          boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
          position: 'relative',
          padding: '32px 20px 20px',
          overflow: 'hidden',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `
              radial-gradient(circle at 20% 80%, rgba(255,255,255,0.1) 0%, transparent 50%),
              radial-gradient(circle at 80% 20%, rgba(255,255,255,0.08) 0%, transparent 50%)
            `,
            pointerEvents: 'none',
          }}
        />

        <button
          onClick={onClose}
          style={{
            border: 'none',
            background: 'rgba(255,255,255,0.3)',
            fontSize: 20,
            position: 'absolute',
            top: 16,
            right: 16,
            cursor: 'pointer',
            width: 32,
            height: 32,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            fontWeight: 'bold',
            zIndex: 10,
          }}
        >
          ✕
        </button>


        <h2
          style={{
            margin: '0 0 10px 0',
            textAlign: 'center',
            color: '#fff',
            fontSize: 28,
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '1px',
            textShadow: '0 2px 4px rgba(0,0,0,0.2)',
            position: 'relative',
          }}
        >
          • MY PET •
        </h2>


        <div style={{
          margin: '0 0 16px 0',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          fontWeight: 700,
          fontSize: 17
        }}>
          <span style={{ color: '#fff', marginRight: 8 }}>All Time High Boost:</span>
          <span style={{
            color: '#ffd700',
            background: '#267dbc',
            borderRadius: 12,
            padding: '2px 18px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            fontWeight: 900,
            fontSize: 18
          }}>
            +{userBonus !== null ? Number(userBonus).toFixed(2) : '...'} /sec
          </span>
        </div>
        <div style={{
          margin: '0 0 12px 0',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          fontWeight: 700,
          fontSize: 16
        }}>
          <span style={{ color: '#fff', marginRight: 8 }}>Total PetForce:</span>
          <span style={{
            color: '#55ffdb',
            background: '#267dbc',
            borderRadius: 12,
            padding: '2px 18px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.09)',
            fontWeight: 900,
            fontSize: 18
          }}>
            {totalSsaltaforce !== null ? Number(totalSsaltaforce) : '...'}
          </span>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', color: '#fff', padding: '40px 0' }}>
            Loading...
          </div>
        ) : error ? (
          <div style={{ textAlign: 'center', color: '#fff', padding: '40px 0' }}>
            Error: {error}
          </div>
        ) : characters.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#fff', padding: '40px 0' }}>
            You don't have any Pet
          </div>
        ) : (
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
              gap: 12,
              maxHeight: 'calc(85vh - 120px)',
              overflowY: 'auto',
              padding: 4,
              position: 'relative',
            }}
          >
            {characters.map((character) => (
              <CharacterCard
                key={character.index}
                character={character}
                onSelect={handleCharacterClick}
              />
            ))}
          </div>
        )}


        <style>
          {`
            @keyframes fadeInOut {
              0% {
                opacity: 0;
                transform: translate(-50%, -50%) scale(0.9);
              }
              10% {
                opacity: 1;
                transform: translate(-50%, -50%) scale(1);
              }
              90% {
                opacity: 1;
                transform: translate(-50%, -50%) scale(1);
              }
              100% {
                opacity: 0;
                transform: translate(-50%, -50%) scale(0.9);
              }
            }
          `}
        </style>
        {selectedCharacter && (
          <CharacterDetailModal
            character={selectedCharacter}
            onClose={handleDetailClose}
            onUpgradeSuccess={handleUpgradeSuccess}
          />
        )}
      </div>
    </div>
  );
}


const gradeStyle = {
  common: { border: '2px solid #B0BEC5', bg: '#ECEFF1', color: '#37474F', label: 'C' },
  rare: { border: '2px solid #4FC3D4', bg: '#E0F7FA', color: '#00838F', label: 'R' },
  epic: { border: '2px solid #BA68C8', bg: '#F3E5F5', color: '#8E24AA', label: 'E' },
  unique: { border: '2px solid #FFB300', bg: '#FFF3E0', color: '#FF6F00', label: 'U' },
  legendary: { border: '2px solid #FFD700', bg: '#FFF9C4', color: '#FFA000', label: 'L' },
};


const GRADE_BONUS = {
  common: 0.01,
  rare: 0.02,
  epic: 0.03,
  unique: 0.05,
  legendary: 0.1
};


function CharacterCard({ character, onSelect }) {
  const [imageError, setImageError] = useState(false);
  const style = gradeStyle[character.grade] || gradeStyle.common;
  const bonusWeight = GRADE_BONUS[character.grade] ?? 1.0;
  const bonusValue = (Number(character.ssaltaforce ?? 0) * bonusWeight).toFixed(2);

  return (
    <div
      onClick={() => onSelect(character)}
      style={{
        border: style.border,
        background: style.bg,
        color: style.color,
        borderRadius: 12,
        padding: 12,
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        transition: 'transform 0.2s, box-shadow 0.2s',
        cursor: 'pointer',
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-4px)';
        e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.2)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
      }}
    >
      <div style={{
        position: 'absolute',
        right: 8,
        top: 8,
        background: style.color,
        color: '#fff',
        fontSize: 11,
        fontWeight: 'bold',
        borderRadius: 8,
        padding: '2px 8px',
        zIndex: 2,
        letterSpacing: '1px',
      }}>
        {style.label}
      </div>
      {character.quantity > 1 && (
        <div
          style={{
            position: 'absolute',
            top: 34,
            right: 8,
            background: 'linear-gradient(135deg, #FF6B6B, #FF5252)',
            color: '#fff',
            fontSize: 11,
            fontWeight: 700,
            padding: '3px 7px',
            borderRadius: 12,
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
            zIndex: 1,
          }}
        >
          ×{character.quantity}
        </div>
      )}
      <div
        style={{
          width: 80,
          height: 80,
          borderRadius: 8,
          background: 'transparent',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 8,
          boxShadow: 'none',
          overflow: 'hidden',
          fontSize: imageError ? '48px' : 'inherit',
        }}
      >
        {imageError ? (
          '🎮'
        ) : (
          <img
            src={character.image}
            alt={character.name}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
            onError={() => setImageError(true)}
          />
        )}
      </div>
      <div style={{
        fontSize: 13,
        fontWeight: 700,
        color: '#333',
        textAlign: 'center',
        lineHeight: 1.2,
        marginTop: 5
      }}>
        {character.name}
      </div>
      <div style={{
        fontSize: 15,
        fontWeight: 900,
        color: '#1fa418',
        background: '#ecf9ee',
        marginTop: 7,
        borderRadius: 7,
        padding: '3px 11px',
        display: 'inline-block'
      }}>
        +{bonusValue} /sec
      </div>
    </div>
  );
}


function CharacterDetailModal({ character, onClose, onUpgradeSuccess }) {
  const [showUpgradeSoon, setShowUpgradeSoon] = useState(false);
  const [showUpgradeConfirm, setShowUpgradeConfirm] = useState(false);
  const [loadingChance, setLoadingChance] = useState(false);
  const [upgradeResult, setUpgradeResult] = useState('');
  const [starforceChance, setStarforceChance] = useState(null);
  const [upgrading, setUpgrading] = useState(false);

  // Auto upgrade 관련 상태
  const [autoUpgrading, setAutoUpgrading] = useState(false);
  const [autoUpgradeCount, setAutoUpgradeCount] = useState(0);
  const [lastAutoUpgradeMessage, setLastAutoUpgradeMessage] = useState(null);
  const [showAutoConfirm, setShowAutoConfirm] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [lastQuantity, setLastQuantity] = useState(null);
  const [targetSsaltaforce, setTargetSsaltaforce] = useState(() => {
    const current = Number(character.ssaltaforce) || 0;
    // 현재+1 ~ 25 중에서, 기본은 25를 쓰되, 현재+1이 25보다 크면 현재+1을 사용
    const maxTarget = 25;
    const minTarget = current + 1;
    return Math.max(minTarget, maxTarget);
  });

  useEffect(() => {
    if (showAutoConfirm) {
      const current = Number(character.ssaltaforce) || 0;
      const maxTarget = 25;
      const minTarget = current + 1;
      // 모달을 열 때마다 기본을 25로, 단 current+1이 25보다 크면 current+1 사용
      setTargetSsaltaforce(Math.max(minTarget, maxTarget));
    }
  }, [showAutoConfirm, character.ssaltaforce]);

  // 모달이 살아있는지 추적
  const isMountedRef = React.useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      // 모달이 닫히거나 언마운트되면 false로
      isMountedRef.current = false;
    };
  }, []);

  const safeSetState = (setter) => {
    if (!isMountedRef.current) return;
    setter();
  };

  const handleUpgradeClick = async () => {
    setShowUpgradeConfirm(true);
    setLoadingChance(true);
    try {
      const { data: { session } } = await supabase.auth.getSession();
      const response = await supabase.functions.invoke('get-starforce-chance', {
        body: JSON.stringify({
          starforce_level: character.ssaltaforce,
        }),
        headers: { Authorization: `Bearer ${session.access_token}` }
      });


      if (response.error) throw new Error(response.error.message);
      setStarforceChance(response.data);
    } catch (err) {
      setStarforceChance(null);
    }
    setLoadingChance(false);
  };

  const handleUpgradeYes = async () => {
    setShowUpgradeConfirm(false);
    setShowUpgradeSoon(true);
    setUpgrading(true);

    try {
      const { data: { session } } = await supabase.auth.getSession();
      const response = await supabase.functions.invoke('try-starforce', {
        body: JSON.stringify({
          starforce_level: character.ssaltaforce,
          index: character.index,
        }),
        headers: { Authorization: `Bearer ${session.access_token}` }
      });

      // 여기서 console.error를 절대 사용하지 않음
      if (response.error) {
        const errMsg =
          typeof response.error === 'string'
            ? response.error
            : response.error?.message
              ? response.error.message
              : "Upgrade failed";
        // 여기서 throw를 해도 catch에서 아무런 출력이 없음
        throw new Error(errMsg);
      }
      setUpgradeResult(response.data.message);

      if (typeof onUpgradeSuccess === 'function') {
        await onUpgradeSuccess();
      }
    } catch (err) {
      // 여기서도 console.error를 절대 사용하지 않음
      setUpgradeResult("Not enough same pet");
      // 원하는 경우 아무런 처리도 안 해도 됨 (최소 메시지 할당만 있음)
    }
    setTimeout(() => {
      setShowUpgradeSoon(false);
      setUpgradeResult('');
      setUpgrading(false);
    }, 2300);
  };

  const handleUpgradeNo = () => setShowUpgradeConfirm(false);

  const callAutoStarforceOnce = async (sessionToken) => {
    const response = await supabase.functions.invoke('test-try-auto-starforce', {
      body: JSON.stringify({
        starforce_level: character.ssaltaforce,
        index: character.index,
        target_ssaltaforce: targetSsaltaforce, // 추가
      }),
      headers: { Authorization: `Bearer ${sessionToken}` }
    });

    if (response.error) {
      const errMsg =
        typeof response.error === 'string'
          ? response.error
          : response.error?.message
            ? response.error.message
            : "Auto upgrade failed";
      throw new Error(errMsg);
    }

    // 서버에서 message, quantity_after, requirement 등을 준다고 가정
    return {
      message: response.data.message,
      result: response.data.result,
      quantity_after: response.data.quantity_after,
      requirement: response.data.requirement,
      ssaltaforce: response.data.ssaltaforce,
    };
  };

  const handleAutoUpgradeConfirmed = async () => {
    if (autoUpgrading || upgrading || loadingChance || character.ssaltaforce >= 25) return;

    safeSetState(() => {
      setAutoUpgrading(true);
      setAutoUpgradeCount(0);
      setLastAutoUpgradeMessage(null);
      setLastQuantity(null);             // 추가
    });

    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session?.access_token) throw new Error('Login required');

      let keepGoing = true;
      let loopCount = 0;

      while (keepGoing && isMountedRef.current) {
        const result = await callAutoStarforceOnce(session.access_token);
        loopCount += 1;

        safeSetState(() => {
          setAutoUpgradeCount(loopCount);
          setLastAutoUpgradeMessage(result.message);
          setLastQuantity(result.quantity_after);         // 남은 재료 업데이트
        });

        if (typeof onUpgradeSuccess === 'function' && isMountedRef.current) {
          await onUpgradeSuccess();
        }

        if (result.stop || result.ssaltaforce >= targetSsaltaforce) {
          keepGoing = false;
        }
        if (result.quantity_after - result.requirement <= 0) {
          keepGoing = false;
        }

        await new Promise((r) => setTimeout(r, 150));
      }
    } catch (err) {
      if (isMountedRef.current && !lastAutoUpgradeMessage) {
        safeSetState(() => {
          setLastAutoUpgradeMessage('Insufficient materials or another reason stopped auto enhancement.')
        });
      }
    }

    if (isMountedRef.current) {
      safeSetState(() => setAutoUpgrading(false));
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.75)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 20,
          minWidth: 320,
          padding: 32,
          position: 'relative',
          boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
        onClick={e => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 16,
            right: 16,
            background: 'rgba(0,0,0,0.1)',
            border: 'none',
            fontSize: 24,
            borderRadius: '50%',
            width: 36,
            height: 36,
            cursor: 'pointer',
          }}
        >✕</button>

        {/* Ssaltaforce 배지 - 절대 위치 왼쪽 위 */}
        {character.ssaltaforce >= 10 && (
          <img
            src={
              character.ssaltaforce >= 20 ? ssalBadge20 :
              character.ssaltaforce >= 15 ? ssalBadge15 :
              ssalBadge10
            }
            alt={`${character.ssaltaforce >= 20 ? '20' : character.ssaltaforce >= 15 ? '15' : '10'}+`}
            style={{
              position: 'absolute',
              left: 8,
              top: 0,
              width: 120,
              height: 'auto',
              zIndex: 10,
            }}
          />
        )}

        <div style={{
          fontSize: 22,
          fontWeight: 700,
          marginBottom: 18,
          color: '#444',
          textAlign: 'center',
        }}>
          {character.name}
        </div>
        <img
          src={character.image}
          alt={character.name}
          style={{
            width: 180,
            height: 180,
            objectFit: 'contain',
            borderRadius: 18,
            marginBottom: 22,
            background: '#f3f3f3',
            boxShadow: '0 0 12px rgba(0,0,0,0.1)',
          }}
        />
        <div style={{ marginBottom: 18, fontSize: 15 }}>
          <strong>Grade:</strong> <span>{character.grade}</span>
        </div>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 18,
        }}>
          <img
            src={ssaltaforceIcon}
            alt="petforce"
            style={{
              width: 24,
              height: 24,
              verticalAlign: 'middle',
              display: 'inline-block',
              marginRight: 8,
            }}
          />
          <span style={{
            fontSize: 24,
            fontWeight: 900,
            color: '#AD9573',
            borderRadius: 13,
            padding: '4px 8px',
            display: 'inline-flex',
            alignItems: 'center',
            height: 24,
            lineHeight: '24px'
          }}>
            x {character.ssaltaforce}
          </span>
        </div>
        {/* 기존 Upgrade 버튼 + 새 Auto Upgrade 버튼 */}
        <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
          <button
            onClick={handleUpgradeClick}
            disabled={loadingChance || upgrading || autoUpgrading || character.ssaltaforce >= 25}
            style={{
              background: 'linear-gradient(135deg, #FFD700, #4FC3D4)',
              color: '#fff',
              fontWeight: 'bold',
              fontSize: 16,
              padding: '10px 10px',
              border: 'none',
              borderRadius: 8,
              cursor: (loadingChance || upgrading || autoUpgrading || character.ssaltaforce >= 25)
                ? 'not-allowed'
                : 'pointer',
              boxShadow: '0 2px 8px rgba(0,0,0,0.18)',
              opacity: (loadingChance || upgrading || autoUpgrading || character.ssaltaforce >= 25) ? 0.6 : 1,
              minWidth: 150,
            }}
          >
            {character.ssaltaforce >= 25 ? "MAX LEVEL" : "PetForce Upgrade"}
          </button>

          <button
            onClick={() => setShowAutoConfirm(true)}
            disabled={loadingChance || upgrading || autoUpgrading || character.ssaltaforce >= 25}
            style={{
              background: 'linear-gradient(135deg, #4FC3D4, #2196F3)',
              color: '#fff',
              fontWeight: 'bold',
              fontSize: 16,
              padding: '10px 10px',
              border: 'none',
              borderRadius: 8,
              cursor: (loadingChance || upgrading || autoUpgrading || character.ssaltaforce >= 25)
                ? 'not-allowed'
                : 'pointer',
              boxShadow: '0 2px 8px rgba(0,0,0,0.18)',
              opacity: (loadingChance || upgrading || autoUpgrading || character.ssaltaforce >= 25) ? 0.6 : 1,
              minWidth: 150,
            }}
          >
            {autoUpgrading ? `Auto Upgrading...(${autoUpgradeCount})` : "Auto Upgrade"}
          </button>
        </div>

        {/* 자동 강화 상태/마지막 메시지 표시 (선택 사항) */}
        {lastAutoUpgradeMessage && (
          <div style={{ marginTop: 10, fontSize: 15, color: '#000', textAlign: 'center' }}>
            {lastQuantity !== null && (
              <>
                Target level: {targetSsaltaforce}
                <br />
                Remaining Materials: <span style={{ color: "#8b724bff", fontWeight: 700 }}>{lastQuantity}</span>
                <br />
              </>
            )}
            {lastAutoUpgradeMessage}
          </div>
        )}


        {showUpgradeConfirm && (
          <div
            style={{
              position: 'absolute',
              top: '45%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              background: 'rgba(33,35,41,0.98)',
              borderRadius: 16,
              padding: '34px 40px',
              minWidth: '280px',
              boxShadow: '0 8px 32px rgba(0,0,0,0.54)',
              zIndex: 1200,
              color: '#fff',
              textAlign: 'center'
            }}
          >
            <div style={{ fontSize: 23, fontWeight: 700, marginBottom: 9, color: '#FFD700' }}>
              Upgrade Probability
            </div>
            <div style={{ fontSize: 17, fontWeight: 500, color: '#e4e1cc', marginBottom: 13 }}>
              {loadingChance ? 'Loading probability...' : (
                <>
                  <div>
                    Success Rate: <span style={{ color: '#08F' }}>{((starforceChance?.success_rate ?? 0) * 100).toFixed(2)}%</span>
                  </div>
                  <div>
                    Destroy Rate: <span style={{ color: '#F44' }}>{((starforceChance?.destroy_rate ?? 0) * 100).toFixed(2)}%</span>
                  </div>
                  <div>
                    Drop Rate: <span style={{ color: '#F44' }}>{((starforceChance?.drop_rate ?? 0) * 100).toFixed(2)}%</span>
                  </div>
                  <div style={{ marginBottom: 10 }}>
                    Keep Rate: <span style={{ color: '#FD0' }}>{((starforceChance?.keep_rate ?? 0) * 100).toFixed(2)}%</span>
                  </div>
                  <div>
                    Required Pet: <span style={{ color: '#FD0' }}>{(starforceChance?.requirement ?? 0)}</span>
                  </div>
                </>
              )}
            </div>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              gap: 18
            }}>
              <button
                onClick={handleUpgradeYes}
                disabled={loadingChance || upgrading}
                style={{
                  background: 'linear-gradient(135deg, #FFD700, #4FC3D4)',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: 16,
                  border: 'none',
                  borderRadius: 10,
                  padding: '9px 26px',
                  cursor: loadingChance || upgrading ? 'not-allowed' : 'pointer',
                  opacity: loadingChance || upgrading ? 0.6 : 1
                }}
              >Yes</button>
              <button
                onClick={handleUpgradeNo}
                style={{
                  background: 'rgba(180,180,180,0.22)',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: 16,
                  border: 'none',
                  borderRadius: 10,
                  padding: '9px 26px',
                  cursor: 'pointer',
                }}
              >No</button>
            </div>
          </div>
        )}


        {showUpgradeSoon && (
          <div
            style={{
              position: 'absolute',
              top: '45%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              background: 'rgba(0,0,0,0.93)',
              borderRadius: 16,
              padding: '28px 40px',
              minWidth: '260px',
              boxShadow: '0 8px 32px rgba(0,0,0,0.54)',
              zIndex: 1200,
              textAlign: 'center',
              color: '#fff',
              animation: 'fadeInOut 2.3s ease-in-out',
            }}
          >
            <div style={{
              fontSize: 24,
              fontWeight: 800,
              background: 'linear-gradient(90deg, #FFD700, #4FC3D4)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              marginBottom: 10,
            }}>
              ⚡ PETFORCE ⚡
            </div>
            <div style={{
              fontSize: 18,
              fontWeight: 600,
              color: '#eee',
            }}>
              {upgradeResult ? upgradeResult : 'Upgrading'}
            </div>
          </div>
        )}

        {showAutoConfirm && (
          <div
            style={{
              position: 'absolute',
              top: '45%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              background: 'rgba(33,35,41,0.98)',
              borderRadius: 16,
              padding: '30px 36px',
              minWidth: '260px',
              boxShadow: '0 8px 32px rgba(0,0,0,0.54)',
              zIndex: 1300,
              color: '#fff',
              textAlign: 'center',
            }}
          >
            <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 10, color: '#FFD700' }}>
              Auto Upgrade
            </div>
            <div
              style={{
                maxHeight: '80vh', // 전체 모달 높이 제한
                overflowY: 'auto', // 세로 스크롤 가능
                padding: 24,
                borderRadius: 18,
                background: '#222', // 예시
                color: '#fff',
              }}
            >
              <button
                onClick={() => setShowDetails(prev => !prev)}
                style={{
                  marginBottom: 8,
                  padding: '4px 10px',
                  borderRadius: 6,
                  border: 'none',
                  cursor: 'pointer',
                  background: 'rgba(0,0,0,0.35)',
                  color: '#fff',
                  fontSize: 14,
                  fontWeight: 600,
                }}
              >
                {showDetails ? 'Hide Warnings' : 'Show Warnings'}
              </button>
              <br />
              {showDetails && (
                <>
                  If enhancement fails, your PetForce level may drop, and from level 13 onward there is a chance of a great failure that can lower it to level 10.<br />
                  Enhancement will continue until you run out of materials, and you can also stop it manually.<br />
                  To stop enhancement, press the X button at the top-right of the enhancement screen or tap outside the screen.<br />
                  If an enhancement request has already been sent to the server just before you stop, that enhancement will complete and then further enhancement will stop.<br />
                  Enhancement materials are consumed as follows: 1 piece at level 9 or below, 2 pieces at level 19 or below, and 3 pieces above that.<br />
                  Enhancement can only proceed if you have at least 1 more material than the required amount.<br /><br />
                </>
              )}

              Have you reviewed the information above before pressing the button?<br /><br />
              Enhancement will start automatically as soon as you press Yes.
            </div>
            <div style={{ marginTop: 12, marginBottom: 12, textAlign: 'left' }}>
              <div style={{ marginBottom: 6, fontWeight: 700, fontSize: 15 }}>
                Target PetForce
              </div>
              <select
                value={targetSsaltaforce}
                onChange={(e) => setTargetSsaltaforce(Number(e.target.value))}
                style={{
                  width: '100%',
                  padding: '6px 10px',
                  borderRadius: 6,
                  border: '1px solid #555',
                  background: '#111',
                  color: '#fff',
                  fontSize: 15,
                }}
              >
                {[...Array.from(
                  { length: 25 - Number(character.ssaltaforce) },
                  (_, i) => Number(character.ssaltaforce) + 1 + i
                )]
                  .reverse()
                  .map((level) => (
                    <option key={level} value={level}>
                      {level}
                    </option>
                  ))}
              </select>
              <div style={{ marginTop: 4, fontSize: 12, color: '#bbb' }}>
                The default value is 25, and you can only select targets higher than your current level.
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', gap: 16 }}>
              <button
                onClick={async () => {
                  setShowAutoConfirm(false);
                  await handleAutoUpgradeConfirmed();
                }}
                disabled={autoUpgrading || upgrading || loadingChance}
                style={{
                  background: 'linear-gradient(135deg, #FFD700, #4FC3D4)',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: 16,
                  border: 'none',
                  borderRadius: 10,
                  padding: '8px 22px',
                  cursor: (autoUpgrading || upgrading || loadingChance) ? 'not-allowed' : 'pointer',
                  opacity: (autoUpgrading || upgrading || loadingChance) ? 0.6 : 1,
                }}
              >
                Yes
              </button>
              <button
                onClick={() => setShowAutoConfirm(false)}
                style={{
                  background: 'rgba(180,180,180,0.22)',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: 16,
                  border: 'none',
                  borderRadius: 10,
                  padding: '8px 22px',
                  cursor: 'pointer',
                }}
              >
                No
              </button>
            </div>
          </div>
        )}

        <style>
          {`
            @keyframes fadeInOut {
              0% {
                opacity: 0;
                transform: translate(-50%, -50%) scale(0.97);
              }
              5% {
                opacity: 1;
                transform: translate(-50%, -50%) scale(1.03);
              }
              80% {
                opacity: 1;
                transform: translate(-50%, -50%) scale(1.01);
              }
              100% {
                opacity: 0;
                transform: translate(-50%, -50%) scale(0.96);
              }
            }
          `}
        </style>
      </div>
    </div>
  );
}
